import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/6b789710f141a55b4cc9b6b517bd545f.jpg"
          alt="Tennis court"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full text-center px-6 py-24">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-lime-400/20 border border-lime-400/40 text-lime-300 text-xs font-semibold uppercase tracking-widest mb-6 backdrop-blur-sm">
          <i className="ri-tennis-ball-fill" />
          The Ultimate Math Sports Challenge
        </div>
        <h1
          className="text-5xl md:text-7xl font-bold text-white leading-tight mb-4"
          style={{ fontFamily: "'Bebas Neue', sans-serif", letterSpacing: '0.04em' }}
        >
          MATH
          <span className="text-lime-400"> TENNIS </span>
          CHALLENGE
        </h1>
        <p className="text-lg md:text-xl text-white/80 max-w-xl mx-auto mb-8 leading-relaxed">
          Serve up your math skills. Every correct answer wins a point in a real tennis match. Master multiplication, volume, and division — one question, one rally at a time.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/level-selector"
            className="px-8 py-3.5 rounded-full bg-lime-400 text-green-900 font-bold text-base hover:bg-lime-300 cursor-pointer transition-all whitespace-nowrap"
          >
            Start Playing
          </Link>
          <Link
            to="/game-overview"
            className="px-8 py-3.5 rounded-full border-2 border-white/40 text-white font-medium text-base hover:bg-white/10 cursor-pointer transition-all whitespace-nowrap backdrop-blur-sm"
          >
            Learn How to Play
          </Link>
        </div>

        {/* Floating stats */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mt-12">
          {[
            { value: '3', label: 'Challenge Types' },
            { value: '4', label: 'Difficulty Levels' },
            { value: '∞', label: 'Questions Generated' },
          ].map(stat => (
            <div key={stat.label} className="text-center">
              <div className="text-3xl font-bold text-lime-400" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>
                {stat.value}
              </div>
              <div className="text-white/60 text-xs uppercase tracking-wider">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-white/50 animate-bounce">
        <i className="ri-arrow-down-line text-xl" />
      </div>
    </section>
  );
}
